export type GenesysCloudIntegrationState = {
  orgPairingLoaded: boolean;
  hasOrgPairingIntegration: boolean;
};

export const initialState = (): GenesysCloudIntegrationState => ({
  hasOrgPairingIntegration: false,
  orgPairingLoaded: false
});
